import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

export const useIsCurrentUserHunterPlus = () => {
  const userRole = useCurrentUserAccessRole();

  return userRole === AccessRoleCodes.HunterPlus;
};
